import { render, staticRenderFns } from "./CreateBusiness.vue?vue&type=template&id=5a94ea30"
import script from "./CreateBusiness.vue?vue&type=script&lang=js"
export * from "./CreateBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports